import { KioskLoadCards } from './KioskLoadCards';

export function KioskBookingsPanel({
  canSelectLoad,
  currentRequestLoadId,
  onOpenDetail,
  onSelectLoad,
  recentOpenRequestLoads,
  registerOperationBlocker,
  requests,
  selectedRequestDirection,
  selectedRequestLoadId,
  showRegisterBlocker,
}) {
  return (
    <div className="kiosk-card">
      <div className="kiosk-card-header">
        <div>
          <h2>รายการใบจอง</h2>
          <p>รายการของและน้ำหนักสินค้าที่กำลังขึ้นรถขนส่ง</p>
        </div>
      </div>
      {showRegisterBlocker && registerOperationBlocker ? (
        <p className="kiosk-blocker">{registerOperationBlocker}</p>
      ) : null}

      <div
        className="kiosk-load-list-scroll"
        role="region"
        aria-label="รายการใบจองทั้งหมด"
        tabIndex={0}
      >
        <KioskLoadCards
          requestLoads={recentOpenRequestLoads}
          requests={requests}
          selectedLoadId={selectedRequestLoadId || currentRequestLoadId}
          selectedLoadDirection={selectedRequestDirection}
          canSelectLoad={canSelectLoad}
          onSelectLoad={onSelectLoad}
          onOpenDetail={onOpenDetail}
        />
      </div>
    </div>
  );
}
